import {
    Alignment,
    Autoformat,
    AutoLink,
    Autosave,
    Bold,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    HorizontalLine,
    InlineEditor,
    Italic,
    Link,
    List,
    ListProperties,
    Paragraph,
    PasteFromOffice,
    RemoveFormat,
    Style,
    TextTransformation,
    Underline
} from 'ckeditor5';

import translations from 'ckeditor5/translations/cs.js';

// import 'ckeditor5/ckeditor5.css';
import '../../sass/cke.css';

// import './style.css';

class S84CkeEditor5InlineExtension {

    constructor() {
        this.plugins = [
            Alignment,
            Autoformat,
            AutoLink,
            Autosave,
            Bold,
            Essentials,
            FontBackgroundColor,
            FontColor,
            FontFamily,
            FontSize,
            GeneralHtmlSupport,
            Heading,
            HorizontalLine,
            Italic,
            Link,
            List,
            ListProperties,
            Paragraph,
            PasteFromOffice,
            RemoveFormat,
            Style,
            TextTransformation,
            Underline
        ];
        this.editors = {};
    }

    initialize(naja) {
        this.naja = naja;
        naja.addEventListener('init', () => {
            this.initAllEditors();
        });

        naja.addEventListener('complete', () => {
            this.initAllEditors();
        });
    }

    initAllEditors() {
        this.initInlineEditors()
    }


    initInlineEditors() {
        let elements = document.querySelectorAll('.has-inline-editor');
        for (let i in elements) {
            if (elements.hasOwnProperty(i)) {
                const elX = elements[i];
                if (elX.dataset.s84Ck5 === 'Y') {
                    continue;
                }
                elX.dataset.s84Ck5 = 'Y';
                this.initSingleInlineEditor(elX);

            }
        }
    }


    initSingleInlineEditor(element) {
        let link = element.dataset.inlineEndpoint;
        console.log(element);
        InlineEditor.create(
            element, {
                toolbar: {
                    items: [
                        'style',
                        'removeFormat',
                        '|',
                        'fontSize',
                        'fontFamily',
                        'fontColor',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'horizontalLine',
                        'link',
                        '|',
                        'alignment',
                        '|',
                        'bulletedList',
                        'numberedList',
                    ],
                    shouldNotGroupWhenFull: false
                },
                plugins: this.plugins,
                fontFamily: {
                    options: [
                        'default',
                        'Exo, sans-serif',
                        'Rubik, sans-serif',
                    ],
                    supportAllValues: true
                },
                fontColor: {
                    colors: [
                        {
                            color: 'rgb(56, 193, 217)',
                            label: 'Modrá',
                        },
                        {
                            color: 'rgb(113, 117, 128)',
                            label: 'Šedá',
                        },
                        {
                            color: 'rgb(15, 27, 36)',
                            label: 'Tmavá šedá',
                        },
                        {
                            color: 'rgb(0, 0, 0)',
                            label: 'Černá',
                        },
                    ],
                },
                fontSize: {
                    options: [10, 12, 14, 'default', 18, 20, 22],
                    supportAllValues: true
                },
                htmlSupport: {
                    allow: [
                        {
                            name: /^.*$/,
                            styles: true,
                            attributes: true,
                            classes: true
                        }
                    ]
                },
                language: 'cs',
                licenseKey: 'GPL',
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'https://',
                    decorators: {
                        toggleDownloadable: {
                            mode: 'manual',
                            label: 'Downloadable',
                            attributes: {
                                download: 'file'
                            }
                        }
                    }
                },
                list: {
                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                },
                placeholder: 'Klikněte sem pro editaci textu.',
                style: {
                    definitions: [
                        // {
                        //     name: 'Article category',
                        //     element: 'h3',
                        //     classes: ['category']
                        // },
                        // {
                        //     name: 'Title',
                        //     element: 'h2',
                        //     classes: ['document-title']
                        // },
                        // {
                        //     name: 'Subtitle',
                        //     element: 'h3',
                        //     classes: ['document-subtitle']
                        // },
                        {
                            name: 'Základní odstavec',
                            element: 'p',
                            classes: ['my-2']
                        },
                        {
                            name: 'Výrazný text 1',
                            element: 'p',
                            classes: ['text-xl font-semibold']
                        },
                        {
                            name: 'Výrazný text 2',
                            element: 'p',
                            classes: ['font-semibold text-blue-charcoal text-2xl/8']
                        },
                        {
                            name: 'Nadpis 1',
                            element: 'p',
                            classes: ['text-5xl/15 xl:text-6xl/20']
                        },
                        {
                            name: 'Nadpis 2',
                            element: 'p',
                            classes: ['text-5xl/15 font-semibold']
                        },
                        {
                            name: 'Nadpis 3',
                            element: 'p',
                            classes: ['text-5xl/15 font-semibold']
                        },


                        // {
                        //     name: 'CTA Link Primary',
                        //     element: 'a',
                        //     classes: ['button', 'button--green']
                        // },
                        // {
                        //     name: 'CTA Link Secondary',
                        //     element: 'a',
                        //     classes: ['button', 'button--black']
                        // },
                        // {
                        //     name: 'Marker',
                        //     element: 'span',
                        //     classes: ['marker']
                        // },
                        // {
                        //     name: 'Spoiler',
                        //     element: 'span',
                        //     classes: ['spoiler']
                        // }
                    ]
                },
                translations: [translations]


                // toolbar: {
                //     // items: [
                //     //     'bold',
                //     //     'italic',
                //     //     'underline',
                //     //     '|',
                //     //     'fontSize',
                //     //     'link',
                //     //     '|',
                //     //     'bulletedList',
                //     //     'numberedList',
                //     //     '|',
                //     //     'blockQuote',
                //     //     'alignment',
                //     //
                //     // ]
                // },
                // fontSize: {
                //     options: [
                //         12,
                //         14,
                //         'default',
                //         20,
                //         24,
                //         28,
                //         32,
                //         36,
                //         40,
                //         48
                //
                //     ]
                // },
                // link: {
                //     decorators: {
                //         openInNewTab: {
                //             mode: 'manual',
                //             label: 'Open in a new tab',
                //             attributes: {
                //                 target: '_blank',
                //                 rel: 'noopener noreferrer'
                //             }
                //         }
                //     }
                // },
                // plugins: this.plugins,
                // language: 'cs',
                // translations: [translations],
                // licenseKey: 'GPL',
            }
        ).then(editor => {
            editor.ui.focusTracker.on('change:isFocused', (evt, name, isFocused) => {
                if (!isFocused) {
                    // Do whatever you want with current editor data:
                    if (link !== undefined) {
                        naja.makeRequest('POST', link, {
                                text: editor.getData()
                            },
                            {
                                history: false,
                            }
                        )
                    }
                }
            });
        });
    }
}

export default S84CkeEditor5InlineExtension;